
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.5 23a.5.5 0 01-.146.354.5.5 0 01-.354.146H6a.5.5 0 01-.5-.5V3a2.5 2.5 0 115 0v20zm8 0a.5.5 0 01-.146.354.5.5 0 01-.354.146h-4a.5.5 0 01-.354-.146A.5.5 0 0113.5 23V3a2.5 2.5 0 014.268-1.768A2.5 2.5 0 0118.5 3v20zM2.5 6a.5.5 0 01-.5.5H1A.5.5 0 01.5 6V1.5a1 1 0 112 0V6zm-1 .5v17m-1-2h2M23.5 6a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V1.5a1 1 0 011.707-.707 1 1 0 01.293.707V6zm-1 .5v17m-1-2h2m-18-11l5-1.498m3 0l5 1.498m-13 5l5-1.498m3 0l5 1.498","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    